export function createImpersonationStore(initial = '') {
    let email = initial;
    const listeners = new Set();
    return {
        getEmail: () => email,
        subscribe(listener) {
            listeners.add(listener);
            return () => listeners.delete(listener);
        },
        setEmail(next) {
            if (next === email)
                return;
            email = next;
            listeners.forEach((l) => l());
        },
    };
}
